import React from 'react';

function Location() {
  return (
    <div className="container">
      <h2 style={{ textAlign: 'center', marginBottom: '3rem' }}>Visit Our Bakery</h2>
      
      <div className="grid-2">
        <div className="card">
          <h3>📍 Location</h3>
          <p style={{ marginTop: '1rem', lineHeight: '1.8' }}>
            <strong>La Provence Bakery</strong><br />
            2855 SW Cedar Hills Blvd. #115<br />
            Beaverton, OR 97005
          </p>
          
          <h3 style={{ marginTop: '2rem' }}>🕒 Operating Hours</h3>
          <ul style={{ marginTop: '1rem', lineHeight: '1.8', listStyle: 'none' }}>
            <li><strong>Monday - Friday:</strong> 6:30 AM - 8:00 PM</li>
            <li><strong>Saturday:</strong> 7:00 AM - 9:00 PM</li>
            <li><strong>Sunday:</strong> 7:00 AM - 6:00 PM</li>
          </ul>
        </div>
        
        {/* Iframe Google Maps Otomatis */}
        <div style={{ width: '100%', height: '100%', minHeight: '350px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
          <iframe 
            title="La Provence Beaverton Location"
            src="https://maps.google.com/maps?q=2855%20SW%20Cedar%20Hills%20Blvd.%20%23115%20Beaverton,%20OR%2097005&t=&z=15&ie=UTF8&iwloc=&output=embed" 
            width="100%" 
            height="100%" 
            style={{ border: 0, minHeight: '350px' }} 
            allowFullScreen="" 
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Location;